import React, { useState } from 'react';
import './CalculatorPage.css';

function CompanyNameCompatibility() {
  const [companyName1, setCompanyName1] = useState('');
  const [companyName2, setCompanyName2] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const calculateNameValue = (name) => {
    let sum = 0;
    const nameMap = {
      'A': 1, 'J': 1, 'S': 1,
      'B': 2, 'K': 2, 'T': 2,
      'C': 3, 'L': 3, 'U': 3,
      'D': 4, 'M': 4, 'V': 4,
      'E': 5, 'N': 5, 'W': 5,
      'F': 6, 'O': 6, 'X': 6,
      'G': 7, 'P': 7, 'Y': 7,
      'H': 8, 'Q': 8, 'Z': 8,
      'I': 9, 'R': 9
    };

    for (let i = 0; i < name.length; i++) {
      const char = name[i].toUpperCase();
      if (nameMap[char]) {
        sum += nameMap[char];
      }
    }
    return sum;
  };

  const calculateCompatibility = (name1, name2) => {
    // Placeholder for Company Name Compatibility calculation logic
    // This is a simplified example; real compatibility would be more complex.
    if (!name1 || !name2) return null;

    const value1 = calculateNameValue(name1);
    const value2 = calculateNameValue(name2);

    // Simple compatibility based on sum of values
    const compatibilityScore = (value1 + value2) % 9 || 9;

    return compatibilityScore;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setResult(null);

    if (!companyName1 || !companyName2) {
      setError('Please enter both company names.');
      return;
    }

    const calculated = calculateCompatibility(companyName1, companyName2);
    if (calculated === null) {
      setError('Invalid input. Please try again.');
    } else {
      setResult(calculated);
    }
  };

  const getExplanation = (score) => {
    return `Compatibility Score ${score}: This is a placeholder explanation for company name compatibility score ${score}.`;
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Company Name Compatibility Calculator",
    "description": "Check the numerological compatibility between two company names.",
    "url": "https://www.yourwebsite.com/company-name-compatibility",
    "potentialAction": {
      "@type": "CalculateAction",
      "name": "Calculate Company Name Compatibility",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.yourwebsite.com/company-name-compatibility?name1={companyName1}&name2={companyName2}",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "query-input": [
        "required name=companyName1",
        "required name=companyName2"
      ]
    }
  };

  return (
    <div className="calculator-page container my-8">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <h1 className="text-center text-primary">Company Name Compatibility</h1>
      <p className="text-center">Enter two company names to check their numerological compatibility.</p>

      <form onSubmit={handleSubmit} className="calculator-form shadow-md rounded-lg p-6">
        <div className="form-group">
          <label htmlFor="companyName1">Company Name 1:</label>
          <input
            type="text"
            id="companyName1"
            className="form-control"
            value={companyName1}
            onChange={(e) => setCompanyName1(e.target.value)}
            placeholder="e.g., Alpha Corp"
          />
        </div>
        <div className="form-group">
          <label htmlFor="companyName2">Company Name 2:</label>
          <input
            type="text"
            id="companyName2"
            className="form-control"
            value={companyName2}
            onChange={(e) => setCompanyName2(e.target.value)}
            placeholder="e.g., Beta Solutions"
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="btn btn-primary">Check Compatibility</button>
      </form>

      {result !== null && (
        <div className="result-section text-center my-8 p-6 shadow-md rounded-lg">
          <h2>Compatibility Score: <span className="result-number">{result}</span></h2>
          <p className="result-explanation">{getExplanation(result)}</p>
        </div>
      )}
    </div>
  );
}

export default CompanyNameCompatibility;
